<template>
  <div style="font-family: 'Montserrat';">
    <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
      <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Audit Settings</v-toolbar-title>
    </v-toolbar>
        <v-container>
          <vue-perfect-scrollbar class="scroll" style="height: 609px">
            <v-layout wrap>
              <v-flex lg12 v-for="(section, index) in sectionKey" :key="index">
                <div class="theme-options ml-5 mr-5">
                  <v-subheader class="px-1 my-2 section-font">
                    {{ section.text }}
                  </v-subheader>
                  <div class="my-3 ml-2">
                    <v-layout row wrap>
                      <v-flex style="margin-top: 5px" lg12 v-for="(correctionCode, number) in assist.tool.isEmpty(correctionReason) ? [] : Object.keys(correctionReason[section.value])" :key="number">
                        <v-icon
                          class="ml-2"
                          :color="correctionReason[section.value][correctionCode].color"
                          hide-details
                          :disabled="correctionReason[section.value][correctionCode].disabled"
                          size="20px"
                          @click="reverseAudit(section.value, correctionCode)"
                        >
                          {{ correctionReason[section.value][correctionCode].icon }}
                        </v-icon>
                        <span style="margin-left: 10px">{{ correctionReason[section.value][correctionCode].text }}</span>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </vue-perfect-scrollbar>
          <v-card-text style="margin-top: 10px">
            <v-layout row>
              <v-flex lg12>
                <v-textarea
                  name="notes"
                  label="Notes"
                  v-model="notes"
                  :disabled="!isAuditStatus()"
                  hide-details
                  multi-line
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-btn :class="actionButtonStyle" :loading="isSubmitted" @click="submittedAction" :disabled="isDisabledSubmitted()">Submitted</v-btn>
          <v-btn v-if="isAuditStatus()" class="ml-7 action-button" @click="discardAction" :disabled="isDisableDiscard()">Discard</v-btn>
        </v-container>
    </div>
</template>
<script>
import { DataType, Tool, Popup } from '@/util/index'
import { RightPanelApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'audit-setting',
  props: {
    loan: Object
  },
  data () {
    return {
      correctionReason: {},
      auditDetails: {},
      auditRecord: {},
      sectionKey: [],
      notes: '',
      isSubmitted: false,
      scrollInvoked: 0,
      assist: {
        tool: tool
      },
      actionButtonStyle: 'ml-7 action-button'
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  destroyed () {
    this.$eventBus.$off('broadcastLockedId')
  },
  mounted () {
    this.$eventBus.$on('broadcastLockedId', target => {
      if (target !== -1) {
        this.correctionReason = {}
        this.auditDetails = {}
        this.auditRecord = {}
        this.sectionKey = []
        this.notes = ''
        this.loadAuditRecordDetails()
      }
    })
  },
  watch: {
    'store.getters.getCorrectionReasonEnum': {
      handler: function () {
        this.assembleCorrectionReason()
      }
    }
  },
  methods: {
    isAuditStatus () {
      return DataType.LoanStatus.UNDERWRITER_REVIEW.value === this.loan.loanStatus ||
        DataType.LoanStatus.TRIBE_REVIEW.value === this.loan.loanStatus || DataType.LoanStatus.TRIBE_NOAA_REVIEW.value === this.loan.loanStatus
    },
    isDisabledSubmitted () {
      return !((DataType.LoanStatus.UNDERWRITER_REVIEW.value === this.loan.loanStatus || DataType.LoanStatus.TRIBE_NOAA_REVIEW.value === this.loan.loanStatus ||
          DataType.LoanStatus.TRIBE_REVIEW.value === this.loan.loanStatus) ||
        ((this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value ||
          this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) && tool.isNotEmpty(this.auditRecord)))
    },
    isDisableDiscard () {
      return tool.isEmpty(this.auditRecord)
    },
    loadAuditRecordDetails () {
      const $this = this
      if (this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value || this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) {
        this.actionButtonStyle = 'ml-7 full-action-button'
      }
      RightPanelApi.listAuditRecordDetails(this.loanId, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.auditRecord = result.auditRecord
          $this.notes = result.auditRecord.notes
          for (const item of result.auditDetails) {
            $this.auditDetails[item.secondaryCode] = item
          }
        }
        $this.assembleCorrectionReason()
      })
    },
    assembleCorrectionReason () {
      this.correctionReason = {}
      this.sectionKey = []

      for (const section of this.store.getters.getCorrectionReasonEnum) {
        if (tool.isEmpty(section)) {
          continue
        }
        if ((this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value && section.value === '28000') ||
          (this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value && section.value !== '28000')) {
          continue
        }
        const correctionItems = {}
        for (const item of section.items) {
          if ((this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value ||
            this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) &&
            tool.isEmpty(this.auditDetails[item.value])) {
            continue
          }
          const dbAuditData = this.auditDetails[item.value]
          const itemData = {}
          itemData.value = item.value
          itemData.text = item.text
          itemData.disable = false
          if ((tool.isEmpty(dbAuditData) || dbAuditData.status === DataType.AuditStatusEnum.VERIFIED.value) &&
            (this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value ||
              this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value || this.loan.loanStatus === DataType.LoanStatus.TRIBE_NOAA_REVIEW.value)) {
            itemData.status = false
            itemData.icon = 'far fa-square'
            itemData.color = '#1483bb'
          } else if ((tool.isNotEmpty(dbAuditData) && dbAuditData.status === DataType.AuditStatusEnum.VERIFIED.value) &&
            (this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value ||
              this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value)) {
            itemData.status = false
            itemData.icon = 'far fa-check-square'
            itemData.color = '#1483bb'
            itemData.disabled = true
          } else {
            itemData.status = true
            itemData.icon = 'fas fa-times-square'
            itemData.color = 'red'
          }
          correctionItems[item.value] = itemData
        }
        if (tool.isEmpty(correctionItems)) {
          continue
        }
        const sectionData = {}
        sectionData.text = section.text
        sectionData.value = section.value
        if (tool.isEmpty(sectionData)) {
          continue
        }
        this.sectionKey.push(sectionData)
        this.correctionReason[section.value] = correctionItems
      }
    },
    reverseAudit (sectionCode, reasonCode) {
      const auditData = this.correctionReason[sectionCode][reasonCode]
      if (auditData.status &&
        (this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value ||
        this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value || this.loan.loanStatus === DataType.LoanStatus.TRIBE_NOAA_REVIEW.value)) {
        auditData.status = false
        auditData.icon = 'far fa-square'
        auditData.color = '#1483bb'
      } else if (auditData.status &&
        (this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value ||
        this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value)) {
        auditData.status = false
        auditData.icon = 'far fa-check-square'
        auditData.color = '#1483bb'
      } else if (!auditData.status) {
        auditData.status = true
        auditData.icon = 'fas fa-times-square'
        auditData.color = 'red'
      }
      this.correctionReason[sectionCode][reasonCode] = auditData
      this.$forceUpdate()
    },
    submittedAction () {
      const $this = this
      this.isSubmitted = true
      if (tool.isEmpty(this.notes) &&
        (this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value ||
          this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value)) {
        popup.popupForWarning('Please enter note content')
        this.isSubmitted = false
        return
      }
      const currentReasonJson = this.correctionReason
      const requestReasonCode = []
      for (const sectionKey of Object.keys(currentReasonJson)) {
        const correctionReason = currentReasonJson[sectionKey]
        for (const reasonCode of Object.keys(correctionReason)) {
          const auditData = correctionReason[reasonCode]
          let data = {}
          if ((this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value || this.loan.loanStatus === DataType.LoanStatus.TRIBE_NOAA_REVIEW.value ||
            this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value) && auditData.status) {
            data = {
              primaryCode: sectionKey,
              secondaryCode: reasonCode,
              status: DataType.AuditStatusEnum.NOT_VERIFIED.value
            }
            $this.auditDetails[reasonCode] = data
            requestReasonCode.push(reasonCode)
          } else if ((this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value ||
            this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) && !auditData.status) {
            data = {
              primaryCode: sectionKey,
              secondaryCode: reasonCode,
              status: DataType.AuditStatusEnum.VERIFIED.value
            }
            $this.auditDetails[reasonCode] = data
            requestReasonCode.push(reasonCode)
          }
        }
      }
      if (tool.isEmpty(requestReasonCode)) {
        popup.popupForWarning('Please select a audit reason')
        $this.isSubmitted = false
        return
      }
      const request = {
        loanId: this.loanId,
        currentLoanStatus: this.loan.loanStatus,
        reasonCodes: requestReasonCode
      }
      if (tool.isNotEmpty(this.auditRecord)) {
        request.auditRecordId = this.auditRecord.id
      }
      if (this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value ||
        this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value || this.loan.loanStatus === DataType.LoanStatus.TRIBE_NOAA_REVIEW.value) {
        request.notes = this.notes
      }
      RightPanelApi.submitAuditRecord(request, function (result) {
        popup.popupForSuccess('Success')
        if (tool.isEmpty($this.auditRecord)) {
          $this.auditRecord.id = result.auditRecordId
        }
        if ($this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value ||
          $this.loan.loanStatus === DataType.LoanStatus.CORRECTOR_REVIEW.value) {
          for (const sectionKey of Object.keys($this.correctionReason)) {
            for (const itemReasonCode of Object.keys($this.correctionReason[sectionKey])) {
              if (!$this.correctionReason[sectionKey][itemReasonCode].status) {
                $this.correctionReason[sectionKey][itemReasonCode].disabled = true
              }
            }
          }
        }
        $this.isSubmitted = false
      }, function (failureData) {
        popup.popupForWarning(failureData.message)
        $this.isSubmitted = false
      })
    },
    discardAction () {
      const $this = this
      if (tool.isEmpty(this.auditRecord)) {
        popup.popupForInfo('There is no audit record')
        return
      }
      const discardRequest = {
        loanId: this.loanId,
        auditRecordId: this.auditRecord.id
      }
      RightPanelApi.discardAuditRecord(discardRequest, function (result) {
        $this.auditDetails = {}
        $this.auditRecord = {}
        $this.notes = ''
        $this.assembleCorrectionReason()
        popup.popupForSuccess('Success')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.section-font{
  font-weight: 700;
  font-size: large;
}
.action-button{
  margin-top: 10px;
  width: 40%;
  color: #5C82E3 !important;
  background: #DEE6F9 !important;
  border-radius: 2px;
  box-shadow: none;
  font-family: 'Montserrat';
}
.full-action-button{
  margin-top: 10px;
  width: 85%;
  color: #5C82E3 !important;
  background: #DEE6F9 !important;
  border-radius: 2px;
  text-transform: none;
  box-shadow: none;
  font-family: 'Montserrat';
}
.toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none;
}
</style>
